import { Tag, Team } from '@bringg/types';

import {
  DEFAULT_NUMBER_OF_TASKS_INTERNAL_DRIVER_DEMO,
  DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
  DEFAULT_TASK_CREATE_INTERVAL_SECONDS,
} from 'Consts';
import { createDeliveryInternalDriver } from 'Services';
import { DemoFlows, DemoSettings } from 'Types';

export const getInternalDriverDemoBackgroundTasks = (teams: Team[], tags: Tag[]): DemoSettings => ({
  name: 'Own Fleet ASAP Simulator',
  demoType: DemoFlows.InternalDriver,
  description: '',
  demoIncludes: [],
  fields: [
    {
      name: 'team',
      label: 'Team',
      value: teams[0],
      component: 'select',
      optionLabel: 'name',
      options: teams,
    },
    {
      name: 'tag',
      label: 'Tag',
      value: tags[0],
      component: 'select',
      optionLabel: 'tag',
      options: tags,
    },
    {
      name: 'phone',
      label: 'Phone Number',
      value: {
        short: 'us',
      },
      component: 'phone',
    },
    {
      name: 'assignDriverIntervalSeconds',
      label: 'Time to assign driver and start in seconds',
      value: DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'shouldGenerateBackgroundTasks',
      label: 'Generate background tasks',
      value: true,
      component: 'checkbox',
    },
    {
      name: 'sleepBetweenTasksStatusCreation',
      label: 'Interval between the orders in seconds',
      value: DEFAULT_TASK_CREATE_INTERVAL_SECONDS,
      component: 'input',
    },
    {
      name: 'ordersToBeCreated',
      label: '# of orders to be created',
      value: DEFAULT_NUMBER_OF_TASKS_INTERNAL_DRIVER_DEMO,
      component: 'input',
    },
  ],
  createTask: createDeliveryInternalDriver,
});
